



import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class ButtonOutlineSuccessful extends Vue {
  @Prop({required: false, type: Boolean, default: false}) isLoading?: boolean
  @Prop({required: true, type: String, default: ''}) text!: string
  @Prop({required: false, type: String, default: 'button'}) type!: string
  @Prop({required: false, type: String, default: '21.188rem'}) buttonWidth!: string
  @Prop({required: false, type: Boolean, default: false}) disabled ?: boolean
  @Prop({required: false, type: String, default: 'success'}) variant ?: string

  private get textButton(): string {
    if (!this.text) return this.$t('common.button.buttonName').toString()
    return this.text
  }

  private get buttonColor(): string {
    if (this.variant == 'warning') return '#F7931E'
    if (this.variant == 'warning-outline') return '#F7931E'
    if (this.variant == 'blue') return '#58C8FF'
    if (this.variant == 'primary') return '#0071BC'
    if (this.variant == 'danger') return '#FA897C'
    return '#66B01D'
  }

  private get image(): string {
    if (this.variant == 'warning') return require('@/assets/images/btn-outline-warning-bg.png')
    if (this.variant == 'warning-outline') return require('@/assets/images/btn-outline-warning-2-bg.png')
    if (this.variant == 'blue') return require('@/assets/images/btn-outline-blue-bg.png')
    if (this.variant == 'primary') return require('@/assets/images/btn-outline-primary-bg.png')
    if (this.variant == 'danger') return require('@/assets/images/btn-outline-danger-bg.png')
    return require('@/assets/images/btn-outline-success-bg.png')
  }

  public onClickToButton(): void {
    this.$emit('clickButton')
  }
}
